import paypal from '../../../assets/icons/paypal.png';
import React from "react";

export default function PayPalAccount ({ email }) {
  return (
    <div className="PayPalAccount">
      <div className="PayPalAccount--card-box">
        <div className="PayPalAccount--card-info">
          <span className="PayPalAccount--icon">
            <img src={paypal} alt="PayPal"/>
          </span>
          <div className="PayPalAccount--card-details">
            <span className="PayPalAccount--email">{email}</span>
            <span className="PayPalAccount--expires">PayPal Account Billing</span>
          </div>
        </div>
      </div>
    </div>
  );
}
